export interface InvoiceReceiptDocument {
  totalAmount?: number | string | null
  whTaxPrice?: number | string | null
  incomeDocumentItems?: Array<{
    beforeVatPrice?: number | string | null
    vatPrice?: number | string | null
    pricePerUnit?: number | string | null
    discountPerUnit?: number | string | null
    quantity?: number | string | null
  }> | null
}

const round2 = (value: number) => Number(value.toFixed(2))
const amount = (value: number | string | null | undefined) => Number(value || 0)

/**
 * ยอด invoice ก่อน/หลัง WHT ต้องมาจากฐานเดียวกันทุกหน้าจอ
 *
 * `totalAmount` ของเอกสารเก่าบางใบถูกเก็บหลังหัก WHT แล้ว จึงใช้ยอดจาก
 * item (ก่อน WHT แต่รวม VAT) เมื่อมี เพื่อไม่ให้หน้าประวัติและหน้ารับชำระ
 * หัก WHT ซ้ำเป็นครั้งที่สอง.
 */
export const invoiceReceiptAmounts = (document: InvoiceReceiptDocument) => {
  const items = document.incomeDocumentItems || []
  const grossFromItems = items.reduce((total, item) => {
    const beforeVat = amount(item.beforeVatPrice)
    const vat = amount(item.vatPrice)
    if (beforeVat || vat) return total + beforeVat + vat

    return (
      total + (amount(item.pricePerUnit) - amount(item.discountPerUnit)) * amount(item.quantity)
    )
  }, 0)

  const grossAmount = round2(grossFromItems > 0 ? grossFromItems : amount(document.totalAmount))
  const withholdingTaxAmount = round2(amount(document.whTaxPrice))
  const settlementAmount = round2(Math.max(0, grossAmount - withholdingTaxAmount))

  return {grossAmount, withholdingTaxAmount, settlementAmount}
}
